import PropTypes from 'prop-types';
import { RequirementPropTypes } from './requirements/prop_types';
export var PasswordPropTypes = {
  behavior: PropTypes.oneOf(['default', 'compact']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  helperText: PropTypes.node,
  hideRequirements: PropTypes.bool,
  id: PropTypes.string,
  i18n: PropTypes.shape({
    requirementsErrorTitle: PropTypes.string.isRequired,
    toggleButtonAriaLabel: PropTypes.string.isRequired
  }),
  error: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  requirements: PropTypes.arrayOf(PropTypes.shape(RequirementPropTypes).isRequired),
  requirementsPlacement: PropTypes.oneOf(['bottom', 'top']),
  separateLabel: PropTypes.bool,
  value: PropTypes.string
};